export default __webpack_public_path__ + "static/media/ic-help.ea252c79.svg";